import {Injectable, OnDestroy} from '@angular/core';
import {AbstractFindAllService} from '../../../../../core/service/v2/service/findAll/abstractFindAll.service';
import {Scanner3dModel} from '../../api/entity/scanner3d.model';
import {Scanner3dRepository} from './ngrx/scanner3d.repository';
import {Scanner3dDataServiceAdapter} from './ngrx/scanner3dDataService.adapter';

@Injectable()
export class Scanner3dFindAllService
    extends AbstractFindAllService<Scanner3dModel, Scanner3dModel>
    implements OnDestroy{

    constructor(repository: Scanner3dRepository, dataServiceAdapter: Scanner3dDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
    ngOnDestroy(): void {
        super.onDestroy();
    }
}
